module.exports = __webpack_public_path__ + "img/resursbank@2x.86da193.png";